// generated by genversion
export var version = '4.5.5';
//# sourceMappingURL=version.js.map